import { styled } from '@mui/material';

export const ButtonsIconsProfile = styled('img')({
  width: '81px',
  height: '81px',
  margin: '0px',
});
